export const VisaListOfModalityOptionsRequiringReasons = [
    '10',
    '11',
    '12',
    '13',
];

export type ModalityOption = { ID: string; value: string; message: string };
export const VisaModalityOptions = [
    {
        ID: 'LIABILITYSHIFTCOUNTERFEITFRAUD',
        value: '10.1',
        message: 'EMV Liability Shift Counterfeit Fraud',
    },
    {
        ID: 'LIABILITYSHIFTNONCOUNTERFEITFRAUD',
        value: '10.2',
        message: 'EMV Liability Shift Non-Counterfeit Fraud',
    },
    {
        ID: 'OTHERFRAUDCARDPRESENT',
        value: '10.3',
        message: 'Other Fraud - Card Present',
    },
    {
        ID: 'OTHERFRAUDCARDABSENT',
        value: '10.4',
        message: 'Other Fraud - Card Absent',
    },
    {
        ID: 'VISAFRAUDMONITORING',
        value: '10.5',
        message: 'Visa Fraud Monitoring Program',
    },
    {
        ID: 'CARDRECOVERYBULLETIN',
        value: '11.1',
        message: 'Card Recovery Bulletin',
    },
    {
        ID: 'DECLINEDAUTHORIZATION',
        value: '11.2',
        message: 'Declined Authorization',
    },
    {
        ID: 'NOAUTHORIZATION',
        value: '11.3',
        message: 'No Authorization',
    },
    {
        ID: 'LATEPRESENTMENT',
        value: '12.1',
        message: 'Late Presentment',
    },
    {
        ID: 'INCORRECTTRANSACTIONCODE',
        value: '12.2',
        message: 'Incorrect Transaction Code',
    },
    {
        ID: 'INCORRECTCURRENCY',
        value: '12.3',
        message: 'Incorrect Currency',
    },
    {
        ID: 'INCORRECTACCOUNTNUMBER',
        value: '12.4',
        message: 'Incorrect Account Number',
    },
    {
        ID: 'INCORRECTAMOUNT',
        value: '12.5',
        message: 'Incorrect Amount',
    },
    {
        ID: 'DUPLICATEPROCESSING',
        value: '12.6.1',
        message: 'Duplicate Processing',
    },
    {
        ID: 'PAIDBYOTHERMEANS',
        value: '12.6.2',
        message: 'Paid by Other Means',
    },
    {
        ID: 'INVALIDDATA',
        value: '12.7',
        message: 'Invalid Data',
    },
    {
        ID: 'MERCHANDISENOTRECEIVED',
        value: '13.1',
        message: 'Merchandise/Services Not Received',
    },
    {
        ID: 'CANCELLEDRECURRING',
        value: '13.2',
        message: 'Cancelled Recurring',
    },
    {
        ID: 'NOTASDESCRIBED',
        value: '13.3',
        message: 'Not as Described or Defective Merchandise/Services',
    },
    {
        ID: 'COUNTERFEITMERCHANDISE',
        value: '13.4',
        message: 'Counterfeit Merchandise',
    },
    {
        ID: 'MISREPRESENTATION',
        value: '13.5',
        message: 'Misrepresentation',
    },
    {
        ID: 'CREDITNOTPROCESSED',
        value: '13.6',
        message: 'Credit Not Processed',
    },
    {
        ID: 'CANCELLEDMERCHANDISESERVICES',
        value: '13.7',
        message: 'Cancelled Merchandise/Services',
    },
    {
        ID: 'ORIGINALCREDITTRANSACTIONNOTACCEPTED',
        value: '13.8',
        message: 'Original Credit Transaction Not Accepted',
    },
    {
        ID: 'NONRECEIPTOFCASHORLOADTRANSACTIONVALUE',
        value: '13.9',
        message: 'Non-Receipt of Cash or Load Transaction Value',
    },
];

export const MastercardModalityOptions = [
    {
        value: '4808',
        message: 'Warning Bulletin File',
        ID: 'WARNINGBULLETINFILE',
    },
    {
        value: '4808',
        message: 'Authorization-Related Chargeback',
        ID: 'AUTHORIZATIONRELATEDCHARGEBACK',
    },
    {
        value: '4808',
        message: 'Account Number Not on File',
        ID: 'ACCOUNTNUMBERNOTONFILE',
    },
    {
        value: '4808',
        message: 'Required Authorization Not Obtained',
        ID: 'REQUIREDAUTHORIZATIONNOTOBTAINED',
    },
    {
        value: '4808',
        message: 'Expired Chargeback Protection Period',
        ID: 'EXPIREDCHARGEBACKPROTECTIONPERIOD',
    },
    {
        value: '4808',
        message: 'Multiple Authorization Requests',
        ID: 'MULTIPLEAUTHORIZATIONREQUESTS',
    },
    {
        value: '4808',
        message: 'Cardholder-Activated Terminal (CAT) 3 Device',
        ID: 'CARDHOLDERACTIVATEDTERMINALDEVICE',
    },
    {
        value: '4834',
        message: 'Point of Interaction Error',
        ID: 'POINTOFINTERACTIONERROR',
    },
    {
        value: '4834',
        message: 'Transaction Amount Differs',
        ID: 'TRANSACTIONAMOUNTDIFFERS',
    },
    {
        value: '4834',
        message: 'Late Presentment',
        ID: 'LATEPRESENTMENT',
    },
    {
        value: '4834',
        message: 'Point-of-Interaction Currency Conversion',
        ID: 'POINTOFINTERACTIONCURRENCYCONVERSION',
    },
    {
        value: '4834',
        message: 'Duplication/Paid by Other Means',
        ID: 'DUPLICATIONPAIDBYOTHERMEANS',
    },
    { value: '4834', message: 'ATM Disputes', ID: 'ATMDISPUTES' },
    {
        value: '4834',
        message: 'Loss, Theft, or Damages',
        ID: 'LOSSTHEFTDAMAGES',
    },
    {
        value: '4837',
        message: 'No Cardholder Authorization',
        ID: 'NOCARDHOLDERAUTHORIZATION',
    },
    {
        value: '4849',
        message: 'Questionable Merchant Activity',
        ID: 'QUESTIONABLEMERCHANTACTIVITY',
    },
    {
        value: '4870',
        message: 'EMV Chip Liability Shift',
        ID: 'EMVCHIPLIABILITYSHIFT',
    },
    {
        value: '4871',
        message: 'EMV Chip/PIN Liability Shift',
        ID: 'EMVCHIPPINLIABILITYSHIFT',
    },
    {
        value: '4853',
        message: 'Cardholder Dispute of a Recurring Transaction',
        ID: 'CARDHOLDERDISPUTEOFARECURRINGTRANSACTION',
    },
    {
        value: '4853',
        message: 'Goods or Services Not Provided',
        ID: 'GOODSORSERVICESNOTPROVIDED',
    },
    {
        value: '4853',
        message: 'No-Show Hotel Charge',
        ID: 'NOSHOWHOTELCHARGE',
    },
    {
        value: '4853',
        message: 'Addendum Dispute',
        ID: 'ADDENDUMDISPUTE',
    },
    {
        value: '4853',
        message: 'Credit Not Processed',
        ID: 'CREDITNOTPROCESSED',
    },
    {
        value: '4853',
        message: 'Goods/Services not as Described or Defective',
        ID: 'GOODSSERVICESNOTASDESCRIBEDORDEFECTIVE',
    },
    {
        value: '4853',
        message: 'Digital Goods $25 or less',
        ID: 'DIGITALGOODS25ORLESS',
    },
    {
        value: '4853',
        message: 'Counterfeit Goods',
        ID: 'COUNTERFEITGOODS',
    },
    {
        value: '4853',
        message: 'Transaction Did Not Complete',
        ID: 'TRANSACTIONDIDNOTCOMPLETE',
    },
    {
        value: '4853',
        message: 'Credit Posted as a Purchase',
        ID: 'CREDITPOSTEDASAPURCHASE',
    },
    {
        value: '4854',
        message: 'Cardholder Dispute Not Classified Elsewhere',
        ID: 'CARDHOLDERDISPUTENOTCLASSIFIEDELSEWHERE',
    },
    {
        value: '4850',
        message: 'Installment Billing Dispute (Participating Countries Only)',
        ID: 'INSTALLMENTBILLINGDISPUTEPARTICIPATINGCOUNTRIESONLY',
    },
    {
        value: '4999',
        message: 'Domestic Chargeback Dispute (Europe Region Only)',
        ID: 'DOMESTICCHARGEBACKDISPUTEEUROPEREGIONONLY',
    },
];
